export class TranscriptComponent {
  public id: number;
  public speakerName?: string;
  public text?: string;

  constructor(transcriptComponent: any) {
    this.id = transcriptComponent.id;
    this.speakerName = transcriptComponent.speakerName;
    this.text = transcriptComponent.text;
  }
}
